import type { Page } from '../../types';

const lineManagerConversation: Page[] = [
  {
    pageType: 'question',
    title: 'Proficiency Rating',
    name: 'proficiency-rating',
    hideSubTitle: true,
    questions: [
      {
        questionType: 'radio',
        title: 'Have you discussed and agreed your assessment level with your line manager?',
        name: 'line-manager-assessment-agreed',
        submitGuard: {
          blockedValues: ['No'],
          message:
            'You must meet with your line manager to agree your assesment before it can be submitted.',
        },
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'date',
                title: 'Date of discussion',
                name: 'line-manager-discussion-date',
                defaultValue: '2026--',
                rules: {
                  required: true,
                },
              },
              {
                questionType: 'textInput',
                title: 'Manager Name',
                name: 'line-manager-name',
                gdpr: 'personal',
                rules: {
                  required: true,
                },
              },
              {
                questionType: 'textInput',
                title: 'Manager Email',
                name: 'line-manager-email',
                gdpr: 'personal',
                approver: true,
                rules: {
                  required: true,
                  email: true,
                },
              },
            ],
          },
          'No',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default lineManagerConversation;

